/*
 * @描述: 路由文件
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2022-11-23 17:36:50
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index'
import store from '@/store'
import {merchantAccount} from '@/utils/index'
Vue.use(VueRouter)
let userInfo = store?.state?.userInfo || {}

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login')
    },
    {
        path: '/',
        name: 'Layout',
        component: Layout,
        redirect: (userInfo && merchantAccount.indexOf(userInfo.phone) > -1) ? '/system/basic_information' : '/system/treeNode',
        children: [
            {
                path: '/system/company',
                name: 'Company',
                component: () => import('@/views/company'),
                meta: {
                    name: '公司管理',
                    icon: 'el-icon-s-home'
                }
            },
            {
                path: '/system/treeNode',
                name: 'navList',
                component: () => import('@/views/treeNode'),
                meta: {
                    name: '菜单管理',
                    icon: 'el-icon-menu'
                }
            },
            {
                path: '/system/version',
                name: 'Version',
                component: () => import('@/views/version'),
                meta: {
                    name: '版本管理',
                    icon: 'iconfont icon-banben'
                }
            },
            {
                path: '/system/appoint',
                name: 'appoint',
                component: () => import('@/views/appoint'),
                meta: {
                    name: '预约管理',
                    icon: 'el-icon-postcard'
                }
            },
            {
                path: '/system/tenant',
                name: 'tenant',
                component: () => import('@/views/tenant'),
                meta: {
                    name: '租户管理',
                    icon: 'el-icon-reading'
                }
            },
            {
                path: '/system/upgrade',
                name: 'upgrade',
                component: () => import('@/views/upgrade'),
                meta: {
                    name: '系统维护',
                    icon: 'el-icon-lock'
                }
            },
            {
                path: '/system/electricity_management',
                name: 'electricity_management',
                component: () => import('@/views/shenlan/electricity_management'),
                meta: {
                    name: '798电费',
                    icon: 'el-icon-s-opportunity'
                }
            },
            {
                path: '/system/exhibition_management',
                name: 'exhibition_management',
                component: () => import('@/views/shenlan/exhibition_management'),
                meta: {
                    name: '展项管理',
                    icon: 'el-icon-s-order'
                }
            },
            {
                path: '/system/exhibition_tpl',
                name: 'exhibition_tpl',
                component: () => import('@/views/shenlan/exhibition_management/exhibition_tpl'),
                meta: {
                    name: '展项管理',
                    icon: 'el-icon-s-order'
                }
            },
            {
                path: '/system/map_guide_management',
                name: 'map_guide_management',
                component: () => import('@/views/shenlan/map_guide_management'),
                meta: {
                    name: '展厅管理',
                    icon: 'el-icon-s-order'
                }
            },
            {
                path: '/system/basic_information',
                name: 'basic_information',
                component: () => import('@/views/shenlan/basic_information'),
                meta: {
                    name: '基础信息',
                    icon: 'el-icon-s-opportunity'
                }
            },
            {
                path: '/system/company_management',
                name: 'company_management',
                component: () => import('@/views/shenlan/company_management'),
                meta: {
                    name: '商户管理',
                    icon: 'el-icon-s-opportunity'
                }
            },



        ]
    }
]

const router = new VueRouter({
    routes
})
router.beforeEach(async (to, from, next) => {
    if(userInfo && merchantAccount.indexOf(userInfo.phone) > -1){
        if(to.name == 'exhibition_management' || to.name == 'exhibition_tpl' || to.name == 'map_guide_management' || to.name =='basic_information' || to.name == 'Login'){
            next()
        }else{
            next({ path: "/system/basic_information" });
        }
    }else{
        next()
    }

})
export default router
